import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SamplePageComponent} from './pages/sample-page/sample-page.component';
import {AdminMasterComponent} from './master-page/admin-master/admin-master.component';
import {AuthGuard} from '../../shared/guards/guards.class';
import {DashboardComponent} from './pages/dashboard/dashboard.component';
import {LoginComponent} from '../auth/login/login.component';
import {PortalMasterComponent} from './master-page/portal-master/portal-master.component';
import {ExportMachineComponent} from './pages/export-warehouse/export-machine/export-machine.component';
import {PatientDetailComponent} from './master-page/patient-detail/patient-detail.component';
import {OrderResultValueComponent} from './pages/order/order-list/order-result-value/order-result-value.component';
import {PrintDoubleTestComponent} from './pages/result/double-test-result/print-double-test/print-double-test.component';
import {LoginAdminComponent} from '../auth/login-admin/login-admin.component';
import {PaymentComponent} from './pages/payment/payment.component';
import {AccountantModule} from './pages/accountant/accountant.module';
import {WarehouseHubComponent} from './pages/warehouse/warehouse-hub/warehouse-hub.component';
import {WarehouseListComponent} from './pages/warehouse/warehouse-list/warehouse-list.component';
import {WarehouseChemicalComponent} from './pages/warehouse/warehouse-chemical/warehouse-chemical.component';
import {ExportWarehouseChemicalComponent} from './pages/export-warehouse/export-warehouse-chemical/export-warehouse-chemical.component';
import {WarehouseInventoryComponent} from './pages/warehouse-inventory/warehouse-inventory/warehouse-inventory.component';
import {InventoryListComponent} from './pages/warehouse-list/inventory-list/inventory-list.component';
import {InventoryReconcilationComponent} from './pages/warehouse/inventory-reconcilation/inventory-reconcilation.component';
import {SearchChemicalComponent} from './pages/export-warehouse/search-chemical/search-chemical.component';
import {WarehouseEvictionComponent} from './pages/warehouse/warehouse-eviction/warehouse-eviction.component';
import {WarehouseConfirmImportComponent} from './pages/warehouse/warehouse-confirm-import/warehouse-confirm-import.component';
import {SmsLogComponent} from './pages/sms-log/sms-log.component';
import {DoctorPatientComponent} from './pages/doctor-patient/doctor-patient.component';
import {DoctorMasterComponent} from './master-page/doctor-master/doctor-master.component';
import {DoctorPricesComponent} from './pages/doctor-prices/doctor-prices.component';
import {ZaloLogComponent} from './pages/zalo-log/zalo-log.component';

const routes: Routes = [
  /* {
     path: "",
     redirectTo: "/admin",
     pathMatch: "full",
   },*/
  {
    path: 'login',
    component: LoginAdminComponent,
  },
  {
    path: 'dashboard',
    component: PortalMasterComponent,
  },
  {
    path: 'doctor',
    component: DoctorMasterComponent,
    children: [
      {
        path: '',
        component: DoctorPatientComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'result',
        component: DoctorPatientComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'prices',
        component: DoctorPricesComponent,
        canActivate: [AuthGuard],
      },
    ]
  },
  {
    path: 'patient/order-detail/:id',
    component: PatientDetailComponent,
  },
  {
    path: 'order-result',
    component: OrderResultValueComponent,
  },
  {
    path: 'print-double-test',
    component: PrintDoubleTestComponent,
  },
  {
    path: 'admin',
    component: AdminMasterComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'warehouse-hub',
        component: WarehouseHubComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: 'import',
            component: WarehouseChemicalComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'confirm-import',
            component: WarehouseConfirmImportComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'export',
            component: ExportWarehouseChemicalComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'inventory',
            component: InventoryListComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'kiem-ke',
            component: InventoryReconcilationComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'chemical-log',
            component: SearchChemicalComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'export-machine',
            component: ExportMachineComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'xuat-kho',
            component: WarehouseEvictionComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'sms-log',
        component: SmsLogComponent,
      },
      {
        path: 'zalo-log',
        component: ZaloLogComponent,
      },
      {
        path: 'payment',
        component: PaymentComponent,
      },
      {
        path: 'welcome',
        loadChildren: () =>
          import(
            '../../shared/component/page-default/page-default.module'
            ).then((s) => s.PageDefaultModule),
        data: {
          pagename: 'welcome',
          breadcrumb: 'Welcome',
        },
      },
      {
        path: 'taikhoan',
        loadChildren: () =>
          import('./pages/taikhoan/taikhoan.module').then(
            (m) => m.TaikhoanModule
          ),
        data: {
          pagename: 'User',
          breadcrumb: 'User Management',
        },
      },
      {
        path: 'nhomtaikhoan',
        loadChildren: () =>
          import('./pages/nhomtaikhoan/nhomtaikhoan.module').then(
            (m) => m.NhomtaikhoanModule
          ),
        data: {
          pagename: 'Group user',
          breadcrumb: 'Group user',
        },
      },
      {
        path: 'banner',
        loadChildren: () =>
          import('./pages/banner/banner.module').then((m) => m.BannerModule),
        data: {
          pagename: 'Banner',
          breadcrumb: 'Banner',
        },
      },
      {
        path: 'customer',
        loadChildren: () =>
          import('./pages/customer/customer.module').then(
            (m) => m.CustomerModule
          ),
        data: {
          pagename: 'Customer',
          breadcrumb: 'Danh sách khách hàng',
        },
      },
      {
        path: 'config',
        loadChildren: () =>
          import('./pages/system-config/system-config.module').then(
            (m) => m.SystemConfigModule
          ),
        data: {
          pagename: 'System config',
          breadcrumb: 'Cấu hình hệ thống',
        },
      },
      {
        path: 'point',
        loadChildren: () =>
          import('./pages/point/point.module').then((m) => m.PointModule),
        data: {
          pagename: 'Point',
          breadcrumb: 'Tích điểm',
        },
      },
      {
        path: 'account',
        loadChildren: () =>
          import('./pages/account/account.module').then((m) => m.AccountModule),
        data: {
          pagename: 'Account',
          breadcrumb: 'Tài khoản',
        },
      },
      {
        path: 'danhmuc',
        loadChildren: () =>
          import('./pages/danhmuc/danhmuc.module').then((m) => m.DanhmucModule),
        data: {
          pagename: 'Category',
          breadcrumb: 'Danh mục',
        },
      },
      {
        path: 'specimen',
        loadChildren: () =>
          import('./pages/spencimen/spencimen.module').then(
            (m) => m.SpencimenModule
          ),
        data: {
          pagename: 'Mẫu XN',
          breadcrumb: 'Mẫu XN',
        },
      },
      {
        path: 'patient',
        loadChildren: () =>
          import('./pages/patient/patient.module').then((m) => m.PatientModule),
        data: {
          pagename: 'Danh sách BN',
          breadcrumb: 'Danh sách BN',
        },
      },
      {
        path: 'order',
        loadChildren: () =>
          import('./pages/order/order.module').then((m) => m.OrderModule),
        data: {
          pagename: 'Chỉ định xét nghiệm',
          breadcrumb: 'Chỉ định xét nghiệm',
        },
      },
      {
        path: 'task',
        loadChildren: () =>
          import('./pages/task/task.module').then((m) => m.TaskModule),
        data: {
          pagename: 'Task xét nghiệm',
          breadcrumb: 'Task xét nghiệm',
        },
      },
      {
        path: 'calibrate',
        loadChildren: () =>
          import('./pages/calibrate/calibrate.module').then(
            (m) => m.CalibrateModule
          ),
        data: {
          pagename: 'Hoạt động calibrate',
          breadcrumb: 'Hoạt động calibrate',
        },
      },
      {
        path: 'quality-control',
        loadChildren: () =>
          import('./pages/quality-control/quality-control.module').then(
            (m) => m.QualityControlModule
          ),
        data: {
          pagename: 'Hoạt động quality control',
          breadcrumb: 'Hoạt động quality control',
        },
      },
      {
        path: 'report-patient',
        loadChildren: () =>
          import('./pages/report-patient/report-patient.module').then(
            (m) => m.ReportPatientModule
          ),
        data: {
          pagename: 'Thống kê theo bệnh nhân',
          breadcrumb: 'Thống kê theo bệnh nhân',
        },
      },
      {
        path: 'request',
        loadChildren: () =>
          import('./pages/request/request.module').then((m) => m.RequestModule),
        data: {
          pagename: 'request',
          breadcrumb: 'request',
        },
      },
      {
        path: 'chemical',
        loadChildren: () =>
          import('./pages/chemical/chemical.module').then(
            (m) => m.ChemicalModule
          ),
        data: {
          pagename: 'chemical',
          breadcrumb: 'Danh sách hóa chất',
        },
      },
      {
        path: 'warehouse/import',
        loadChildren: () =>
          import('./pages/warehouse/warehouse.module').then(
            (m) => m.WarehouseModule
          ),
        data: {
          pagename: 'Quản lý nhập kho hóa chất',
          breadcrumb: 'Quản lý nhập kho hóa chất',
        },
      },
      {
        path: 'warehouse/consumableRate',
        loadChildren: () =>
          import(
            './pages/warehouse-controller/warehouse-controller.module'
            ).then((m) => m.WarehouseControllerModule),
        data: {
          pagename: 'Quản lý định mức tiêu hao',
          breadcrumb: 'Quản lý định mức tiêu hao',
        },
      },
      {
        path: 'warehouse/inventory',
        loadChildren: () =>
          import('./pages/warehouse-list/warehouse-list.module').then(
            (m) => m.WarehouseListModule
          ),
        data: {
          pagename: 'Quản lý tồn kho hóa chất',
          breadcrumb: 'Quản lý tồn kho hóa chất',
        },
      },
      {
        path: 'warehouse/export',
        loadChildren: () =>
          import('./pages/export-warehouse/export-warehouse.module').then(
            (m) => m.ExportWarehouseModule
          ),
        data: {
          pagename: 'Quản lý xuất kho hóa chất',
          breadcrumb: 'Quản lý xuất kho hóa chất',
        },
      },
      {
        path: 'warehouse/warehouse-inventory',
        loadChildren: () =>
          import('./pages/warehouse-inventory/warehouse-inventory.module').then(
            (m) => m.WarehouseInventoryModule
          ),
        data: {
          pagename: 'Kiểm kê kho',
          breadcrumb: 'Kiểm kê kho',
        },
      },
      {
        path: 'warehouse/re-input',
        loadChildren: () =>
          import('./pages/re-input-warehouse/re-input-warehouse.module').then(
            (m) => m.ReInputWarehouseModule
          ),
        data: {
          pagename: 'Nhập lại từ máy xét nghiệm',
          breadcrumb: 'Nhập lại từ máy xét nghiệm',
        },
      },
      {
        path: 'warehouse/move-to-other-machine',
        loadChildren: () =>
          import(
            './pages/move-to-other-machine/move-to-other-machine.module'
            ).then((m) => m.MoveToOtherMachineModule),
        data: {
          pagename: 'Chuyển hóa chất sang máy XN khác',
          breadcrumb: 'Chuyển hóa chất sang máy XN khác',
        },
      },
      {
        path: 'warehouse',
        loadChildren: () =>
          import('./pages/warehouse/warehouse.module').then(
            (m) => m.WarehouseModule
          ),
        data: {
          pagename: 'Quản lý kho',
          breadcrumb: 'Quản lý kho',
        },
      },
      {
        path: 'patients',
        loadChildren: () =>
          import('./pages/patients/patients.module').then(
            (m) => m.PatientsModule
          ),
        data: {
          pagename: 'Danh sách bệnh nhân',
          breadcrumb: 'Danh sách bệnh nhân',
        },
      },
      {
        path: 'result',
        loadChildren: () =>
          import('./pages/result/result.module').then((m) => m.ResultModule),
        data: {
          pagename: 'Kết quả xét nghiệm',
          breadcrumb: 'Kết quả xét nghiệm',
        },
      },
      {
        path: 'ke-toan',
        loadChildren: () =>
          import('./pages/accountant/accountant.module').then(
            (m) => m.AccountantModule
          ),
        data: {
          pagename: 'Kế toán',
          breadcrumb: 'Kế toán',
        },
      },
      {
        path: 'report',
        loadChildren: () =>
          import('./pages/reports/reports.module').then((m) => m.ReportsModule),
        data: {
          pagename: 'Báo cáo',
          breadcrumb: 'Báo cáo',
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminLayoutRoutingModule {
}
